import { IContextualMenuProps } from '@fluentui/react';
import { IPActionButton, IPDefaultButton, IPImage, IPSpinner, IPText, IPTooltipHost } from 'baseComponents';
import { IPSpinnerSize } from 'baseComponents/Spinner/IPSpinner';
import { IPStack } from 'baseComponents/Stack/IPStack';
import {
  copilotIconProps,
  globalStackTokensGapExtraSmall,
  globalStackTokensGapSmall,
  globalTextStylesBoldBlack,
  globalTextStylesBoldWhite,
  imagePropsCopilotImageButton,
} from 'globalStyles';

interface ICopilotButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  text?: string;
  tooltip?: string;
  showSpinner?: boolean;
  isPrimary?: boolean;
  // Turns the action button into a menu: several AI actions that belong together are offered from
  // one button instead of standing next to each other in the command row.
  menuProps?: IContextualMenuProps;
}

export const CopilotButton = (props: ICopilotButtonProps) => {
  //
  // Main render
  //
  return (
    <IPTooltipHost content={props.tooltip}>
      <IPDefaultButton
        primary={props.isPrimary}
        disabled={props.disabled || props.showSpinner}
        onClick={() => props.onClick?.()}
      >
        <IPStack horizontal tokens={globalStackTokensGapSmall} verticalAlign="center">
          <IPStack.Item>
            <IPImage {...imagePropsCopilotImageButton} />
          </IPStack.Item>
          <IPStack.Item>
            <IPText styles={props.isPrimary ? globalTextStylesBoldWhite : globalTextStylesBoldBlack}>
              {props.text}
            </IPText>
          </IPStack.Item>
          {props.showSpinner && (
            <IPStack.Item>
              <IPSpinner size={IPSpinnerSize.small} />
            </IPStack.Item>
          )}
        </IPStack>
      </IPDefaultButton>
    </IPTooltipHost>
  );
};

export const CopilotActionButton = (props: ICopilotButtonProps) => {
  //
  // Main render
  //
  return (
    <IPTooltipHost content={props.tooltip}>
      <IPStack horizontal tokens={globalStackTokensGapExtraSmall} verticalAlign="center">
        <IPStack.Item>
          <IPActionButton
            text={props.text}
            iconProps={copilotIconProps}
            onClick={props.onClick ? () => props.onClick?.() : undefined}
            menuProps={props.menuProps}
            disabled={props.disabled || props.showSpinner}
          />
        </IPStack.Item>
        {props.showSpinner && (
          <IPStack.Item>
            <IPSpinner size={IPSpinnerSize.small} />
          </IPStack.Item>
        )}
      </IPStack>
    </IPTooltipHost>
  );
};
